module.exports = __webpack_public_path__ + "img/ocaml.edc04183.svg";